export default __webpack_public_path__ + "static/media/srisailamVisitTen.c06d172e.jpg";